import React, { Component } from 'react';
import SideBar from '../SideBar/SideBar';
import '../TicketBooking/TicketBooking.css'
import { toast } from 'react-toastify';
import Loader from '../Components/Utils/AnLoader/Loader'
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from "../Constant/axios"
export default class CityMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            CityMasterData: [],
            serialNo: 1,
            selectedRowToEdit: []

        };

    }

    componentDidMount() {
        // var login = localStorage.getItem("token")
        // if (login === null || login === undefined) window.location.href = "/";
    }

    componentWillUnmount() {
        this.getCityDetail()
    }
    getCityDetail = () => {
        debugger
        axios.get(`/getCityDetail`).then((res) => {
            if (res && res.data && res.data.data) {
                res.data.data.forEach(e => {
                    e.isDisabled = true
                });
                this.setState({ CityMasterData: res.data.data, loading: false, });
            } else {
                this.setState({ CityMasterData: [], loading: false, });
            }
        },
            (err) => {
                console.log(err);
            }
        );
    }

    handleCityCode = (cell, val) => {
        debugger
        var CityMasterData = this.state.CityMasterData
        for (let i = 0; i < CityMasterData.length; i++) {
            if (cell.srno && cell.srno == CityMasterData[i].srno) {
                CityMasterData[i].city_code = val
                CityMasterData[i].cr_by = this.state.userId
                CityMasterData[i].isUpdated = true
            }
        }
        this.setState({ CityMasterData })
    }
    handleCityName = (cell, val) => {
        debugger
        var CityMasterData = this.state.CityMasterData
        for (let i = 0; i < CityMasterData.length; i++) {
            if (cell.srno && cell.srno == CityMasterData[i].srno) {
                CityMasterData[i].city_name = val
                CityMasterData[i].cr_by = this.state.userId
                CityMasterData[i].isUpdated = true
            }
        }
        this.setState({ CityMasterData })
    }

    HandleAddNewRow = () => {
        let CityMasterData = this.state.CityMasterData
        let newJob = {
            temp_id: CityMasterData.length + 1,
            srno: CityMasterData.length + 1,
            city_code: "",
            city_name: "",
        }
        CityMasterData.unshift(newJob)
        this.setState({ CityMasterData })
    }


    handledit = (cell, e) => {
        this.setState({ selectedRowToEdit: [] })

        var selectedRowToEdit = this.state.selectedRowToEdit
        selectedRowToEdit.push(cell)
        this.setState({ selectedRowToEdit })

        this.state.selectedRowToEdit.forEach(e => {
            e.isDisabled = false
        });
    }

    handleDeleteRecord = (cell) => {
        var TicketData = []

        var selectedRow = {
            Srno: cell.srno,
            id: cell.id,
            del_by: this.state.userId,
            isUpdated: true
        }
        TicketData.push(selectedRow)

        let masterData = {
            data: TicketData
        }

        Swal.fire({
            title: 'Are you sure you want to delete?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DB4444',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                const options = this.state.CityMasterData.filter((item) => {
                    return item.srno !== cell.srno
                })


                this.setState({ CityMasterData: options })
                Swal.fire(
                    'Deleted!',
                    'Your Data has been Deleted.',
                    'success'
                )

            } else {

            }
        }).catch((error) => {
            // Handle error
        });
    }

    handleDataSave = () => {
        var CityMasterData = [];
        for (var i = 0; i < this.state.CityMasterData.length; i++) {

            if (this.state.CityMasterData[i].isUpdated === true) {
                if (this.state.CityMasterData[i].city_name === "" || this.state.CityMasterData[i].city_name === "") {
                    toast.error(`Please fill in input fields in Row No. ${this.state.CityMasterData[i].srno}`)
                    return false;
                }

                CityMasterData.push(this.state.CityMasterData[i])
            }
        }
        if (CityMasterData.length > 0) {
            CityMasterData = { data: CityMasterData }

            this.setState({ loading: true })

            axios.post(`/saveCityDetail`, CityMasterData).then((res) => {
                if(res.data.success === "success"){
                Swal.fire({
                    icon: "success",
                    title: "Your data has been saved in below table",
                    showConfirmButton: false,
                    timer: 2000
                });
                this.getCityDetail()
            }
            })
        }
        else {
            Swal.fire({
                icon: "error",
                title: "No any new data in above table",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }
    render() {

        return (
            // this.state.loading ? <Loader /> :
            <div className="container-fluid">
                <div className="row mt-2">
                    <div className="col-md-2">
                        <SideBar ScreenName={"City Master"} />
                    </div>
                    <div className="col-md-10">
                        <div className="container h-100 poDetailsContainer_media" style={{ marginTop: "73px", backgroundColor: "#f9fbfd", width: "96%", marginLeft: "34px" }}>
                            <div className="row m-0 p-0 align-items-center justify-content-center mb-3">
                                <div className="col-md-8 mt-3">
                                    <h4 className='FontB'><b>City Master</b></h4>
                                </div>
                                <div className="col-md-4 mt-2 m-0 p-0 text-end mt-3">
                                    <button onClick={() => this.HandleAddNewRow()} className="btn-sm  buttonBorder me-2" style={{ cursor: "pointer" }}>Add New Row</button>

                                    {/* </div>
                                    <div className="col-md-2  mt-3"> */}
                                    <button type="submit" onClick={() => this.handleDataSave()} className="btn-sm buttonBorder2G" style={{ cursor: "pointer", color: 'white' }}>Save</button>

                                </div>

                            </div>

                            <div class="table-responsive">
                                {this.state.loading ? <Loader /> :
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className='thBg' scope="col" >Sr No </th>
                                                <th className='thBg' scope="col" style={{ minWidth: "300px", textAlign: "center" }}>City Code</th>
                                                <th className='thBg' scope="col" style={{ minWidth: "300px", textAlign: "center" }}>City Name </th>
                                                <th className='thBg' scope="col" style={{ minWidth: "300px", textAlign: "center" }}>Operations </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.CityMasterData.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td style={{ textAlign: "center" }}> {index + 1}</td>
                                                    <td style={{ textAlign: "center" }}><input className="form-control" type="text" value={item.city_code} disabled={item.isDisabled} onChange={(e) => this.handleCityCode(item, e.target.value)} /></td>
                                                    <td style={{ textAlign: "center" }}> <input className="form-control" type="text" value={item.city_name} disabled={item.isDisabled} onChange={(e) => this.handleCityName(item, e.target.value)} /></td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <FontAwesomeIcon
                                                            icon={faEdit}
                                                            onClick={(e) => this.handledit(item, index, e)}
                                                            style={{ color: "#227446", fontSize: "18px", paddingRight: '9px', cursor: 'pointer' }}
                                                        />
                                                        {item.temp_id &&
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                onClick={(e) => this.handleDeleteRecord(item, index, e)}
                                                                style={{ cursor: 'pointer', color: "red", borderleft: '1px solid black', paddingleft: '9px', fontSize: "18px", marginLeft: '10px' }}
                                                            />
                                                        }
                                                    </td>

                                                </tr>
                                            ))}
                                            {(this.state.CityMasterData.length === 0 &&
                                                <td colSpan={4} style={{ fontFamily: "poppins", textAlign: "center" }}> No Data Present</td>
                                            )}
                                        </tbody>

                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

